import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { KavSharedModule } from '@kav/shared.module';

import { ContentComponent } from 'app/layout/components/content/content.component';

@NgModule({
    declarations: [
        ContentComponent
    ],
    imports     : [
        RouterModule,
        KavSharedModule
    ],
    exports     : [
        ContentComponent
    ]
})
export class ContentModule
{
}
